import { cva as r } from "class-variance-authority";
import * as t from "react";
import { c as n } from "../cn-Edy-X8i3.js";
import "clsx";
import "tailwind-merge";
const a = r(
  "inline-flex items-center gap-1.5 whitespace-nowrap rounded-sm border px-2 py-1 text-sm font-medium",
  {
    variants: {
      intent: {
        neutral: "bg-gray-25 text-secondary",
        success: "border-green-600 bg-green-600 text-primary-inverted",
        warning: "border-yellow-200 bg-yellow-50 text-warning",
        critical: "border-red-200 bg-red-200 text-primary font-normal",
        danger: "border-red-600 bg-red-600 text-primary-inverted"
      }
    },
    defaultVariants: {
      intent: "neutral"
    }
  }
);
function l(e) {
  return /* @__PURE__ */ t.createElement(
    "span",
    {
      className: n(a({ intent: e.intent }), e.className)
    },
    e.children
  );
}
export {
  l as Alert
};
